'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _utils = require('./../utils');

var _reactstrap = require('reactstrap');

var _AutocompleteField = require('./AutocompleteField');

var _AutocompleteField2 = _interopRequireDefault(_AutocompleteField);

var _storeSuggestActions = require('../actions/storeSuggestActions');

var StoreSuggest = _interopRequireWildcard(_storeSuggestActions);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Store suggest
 *
 * Field který automatický vytvoří store pod danou AREA a zavolá api a zobrazí autocompleteField
 */
var StoreSuggestField = function (_React$Component) {
    (0, _inherits3.default)(StoreSuggestField, _React$Component);

    function StoreSuggestField() {
        (0, _classCallCheck3.default)(this, StoreSuggestField);
        return (0, _possibleConstructorReturn3.default)(this, (StoreSuggestField.__proto__ || (0, _getPrototypeOf2.default)(StoreSuggestField)).apply(this, arguments));
    }

    (0, _createClass3.default)(StoreSuggestField, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _props = this.props,
                area = _props.area,
                apiCall = _props.apiCall;

            this.props.dispatch(StoreSuggest.fetchListIfNeeded(area, apiCall));
        }
    }, {
        key: 'render',
        value: function render() {
            var _props2 = this.props,
                store = _props2.store,
                other = (0, _objectWithoutProperties3.default)(_props2, ['store']);


            if (!store || !store.fetched) {
                return _react2.default.createElement(_reactstrap.Input, {
                    type: 'text',
                    disabled: true
                });
            }

            return _react2.default.createElement(_AutocompleteField2.default, (0, _extends3.default)({
                items: store.rows
            }, other));
        }
    }]);
    return StoreSuggestField;
}(_react2.default.Component);

StoreSuggestField.PropTypes = {
    area: _react2.default.PropTypes.string.isRequired,
    apiCall: _react2.default.PropTypes.func.isRequired
};


function mapStateToProps(state, props) {
    return {
        store: (0, _utils.storeFromArea)(state, props.area, false)
    };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)(StoreSuggestField);
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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